module.exports = __webpack_public_path__ + "img/cancel.b07d8d65.jpg";